import type { StateCreator } from "zustand";

const beforeListener = [];
const afterListener = [];

type storeSetHookMiddireImpl = <T extends object>(
  storeInitializer: StateCreator<T, [], []>
) => StateCreator<T, [], []>;

// api上添加、beforeSet、afterSet方法类型
declare module "zustand" {
  export interface StoreApi<T> {
    // @ts-ignore
    setState: (
      partial: T | Partial<T> | ((state: T) => T | Partial<T>),
      replace?: boolean,
      skipHook?: Boolean
    ) => void;
    beforeSet: (fn: (nextState: T, replace: boolean) => void) => void;
    afterSet: (fn: (nextState: T, replace: boolean) => void) => void;
    removeBeforeSet: (fn: (nextState: T, replace: boolean) => void) => void;
    removeAfterSet: (fn: (nextState: T, replace: boolean) => void) => void;
  }
}
/**
 * @description: zustand 中间件，用于在setstore之前、之后增加钩子，能够在中间做一些事情
 * @param fn
 * @returns
 */
export const storeSetHookMiddire: storeSetHookMiddireImpl =
  (fn) => (set, get, api) => {
    const wrapSet = (partial, replace, skipHook) => {
      const currentState = get();
      const nextState =
        typeof partial === "function" ? partial(currentState) : partial;

      !skipHook &&
        beforeListener.forEach((fn) => {
          try {
            fn(nextState, replace);
          } catch (error) {
            console.error("before set store error", error);
          }
        });

      set(nextState, replace);

      !skipHook &&
        afterListener.forEach((fn) => {
          try {
            fn(nextState, replace);
          } catch (error) {
            console.error("after set store error", error);
          }
        });
    };

    // @ts-ignore
    api.setState = wrapSet;

    api.beforeSet = (fn) => {
      beforeListener.push(fn);
    };

    api.removeBeforeSet = (fn) => {
      const index = beforeListener.indexOf(fn);
      if (index > -1) {
        beforeListener.splice(index, 1);
      }
    };

    api.afterSet = (fn) => {
      afterListener.push(fn);
    };

    api.removeAfterSet = (fn) => {
      const index = afterListener.indexOf(fn);
      if (index > -1) {
        afterListener.splice(index, 1);
      }
    };

    // @ts-ignore
    const initialState = fn(wrapSet, get, api);
    return initialState;
  };
